import { type Decision, decidePalletTagBatchDelete, palletTagPolicy } from '@shared/core/policy';
import { useMemo } from 'react';

import { usePolicyEvaluator } from 'src/modules/policy';

import { toPalletTagFacts } from './palletTagFacts';

type DeletableTag = Parameters<typeof toPalletTagFacts>[0];

/**
 * The toolbar's Delete, asked the way `deletePalletTags` answers it: one `delete` decision per
 * selected tag, folded into the bulk door's one answer (and its one sentence).
 */
export const usePalletTagsDeleteDecision = (tags: readonly DeletableTag[]): Decision => {
  const decide = usePolicyEvaluator(palletTagPolicy);

  return useMemo(
    () => decidePalletTagBatchDelete(tags.map((tag) => decide(toPalletTagFacts(tag), { type: 'delete' }))),
    [decide, tags]
  );
};
